import {
    mapActions,
    mapGetters,
    mapState,
} from 'vuex';
import {
    filter,
    reject,
} from 'lodash';

export default {

    data: () => ({
        isBilling: false,
        isSideNav: false,
    }),

    computed: {
        ...mapState(['user', 'currentSubscription']),
        ...mapGetters(['isLifetimeSubscriptionSelected']),

        /**
         * Filtered active subscriptions array.
         *
         * @returns {Array} Active subscriptions.
         */
        subscriptions() {
            const allSubscriptions = filter(this.user.subscriptions, (subscription) => {
                const status = subscription.stripe_status;
                return 'active' === status || 'past_due' === status;
            });

            // Returns subscription list without free
            if (! this.isSubscriptionPage) return reject(allSubscriptions, { name: 'free' });

            return (this.isSideNav)
                ? filter(allSubscriptions, { name: 'lifetime' })
                : reject(allSubscriptions, { name: 'lifetime' });
        },

        /**
         * Whether the switch is visible (only if there are more than 1 active subscriptions)
         *
         * @returns {boolean} Whether to show the switch.
         */
        isVisible() {
            return (this.isLifetimeSubscriptionSelected)
                ? false
                : this.currentSubscription && 1 < this.subscriptions.length;
        },
    },

    /**
     *  Created hook
     */
    created() {
        this.checkSubscriptionPage();
    },

    methods: {
        ...mapActions([
            'loadUserSubscription',
            'loadInvoices',
            'loadUpcomingInvoice',
        ]),

        /**
         * Handles plan switching.
         *
         * @param  {object} subscription Subscription.
         * @returns {void}
         */
        handleClick(subscription) {
            const { id } = subscription;
            this.loadUserSubscription({ id });
        },

        /**
         * Checks if is page with loaded subscription
         */
        checkSubscriptionPage() {
            if (this.$route.fullPath.includes('/settings')) this.isSubscriptionPage = true;
        },

    },
};
